import { memo } from "react";
import { useTranslation } from "react-i18next";

import { PATHS } from "@/constants/paths";
import { useOnPremise } from "@/hooks/use-on-premise";
import { FLAVOR_CONFIG } from "@/lib/flavor-config";

export const Footer = memo(() => {
  const { t } = useTranslation("common");
  const { isOnPremise } = useOnPremise();

  return (
    <div
      data-testid="app-footer"
      className="h-[var(--footer-height)] px-4 items-center hidden md:flex bg-background"
    >
      {!isOnPremise && FLAVOR_CONFIG.socialLinks && (
        <div className="flex items-center gap-8">
          {FLAVOR_CONFIG.socialLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              target="_blank"
              rel="noreferrer"
              className="text-muted-foreground text-sm"
            >
              {link.label}
            </a>
          ))}
        </div>
      )}
      <div className="ms-auto flex items-center gap-8">
        {/* NOTE: Plain <a>, not a router Link — /docs is proxied to the
            Docusaurus site behind forward_auth, not an SPA route. Opens in a
            new tab so users don't lose their current chat/page context. */}
        <a
          href={PATHS.DOCS}
          target="_blank"
          rel="noopener noreferrer"
          className="text-muted-foreground text-sm"
          data-testid="footer-docs-link"
        >
          {t("footer.docs")}
        </a>
        <span className="text-muted-foreground text-sm">
          {/* NOTE: NSAI-6321 — deliberately NOT the organization's platform
              name. This line names the copyright holder, which is the vendor
              and stays the vendor whatever an organization calls the product;
              an organization's own name here would assert it owns the
              software. The rename covers the product name only. */}
          {new Date().getFullYear()} © {FLAVOR_CONFIG.companyName}
        </span>
      </div>
    </div>
  );
});
